import { render } from "./gallery-modal.vue?vue&type=template&id=82847168&scoped=true"
import script from "./gallery-modal.vue?vue&type=script&lang=js"
export * from "./gallery-modal.vue?vue&type=script&lang=js"

import "./gallery-modal.vue?vue&type=style&index=0&id=82847168&lang=sass&scoped=true"

import exportComponent from "/Users/ohirjak/projects/mov-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82847168"]])

export default __exports__